/**
 * Created by Ivan on 10.03.2026
 */

const HungryGamesStartWindow = Prefab.createWindow("hungry_games_start_window", "hungrygamesstartwindow_prefab_json");
